// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-fix {
  padding-bottom: 0px;
  padding-left: 0px;
}

.title-fix-container::before {
  display: none;
}

.input-fix {
  width: 100%;
}

.delete {
  padding-bottom: 1.5rem;
}

.setting-button {
  padding-left: 0px;
}

:host ::ng-deep .setting-button .mdc-button__label {
  display: flex;
  align-items: center;
  text-transform: uppercase;
  gap: 8px; /* Adjust the gap between the image and text */
}`, "",{"version":3,"sources":["webpack://./src/core/components/add-saved-settings-dialog/add-saved-settings-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA,EAAA,8CAAA;AAJJ","sourcesContent":[".title-fix {\n    padding-bottom: 0px;\n    padding-left: 0px;\n}\n\n.title-fix-container::before {\n    display: none;\n}\n\n.input-fix {\n    width: 100%;\n}\n\n.delete {\n    padding-bottom: 1.5rem;\n}\n\n.setting-button {\n    padding-left: 0px;\n\n    // .mdc-button__label {\n    //     display: flex;\n    //     align-items: center;\n    // }\n}\n\n:host ::ng-deep .setting-button .mdc-button__label {\n    display: flex;\n    align-items: center;\n    text-transform: uppercase;\n    gap: 8px; /* Adjust the gap between the image and text */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
